var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"parentBox",staticClass:"race-notice-box"},[_c('div',{ref:"msg1",staticClass:"race-notice-text",style:({ left: _vm.left1 + 'px' })},[_vm._v(_vm._s(_vm.msg))]),_c('div',{staticClass:"race-notice-text",style:({ left: _vm.left2 + 'px' })},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }